import { createContext } from "react";

export const BookingContext = createContext(null);

export default { BookingContext }